<template>
  <div class="dashboard_page">
    <div class="d-flex justify-between items-center pb-8">
    <div class="db_head pb-0">
      <h4>Dashboard</h4>
      <!-- <p>Hi {{checkProperty(getUserData, 'name')}}, We help you to prioritize your task and attention.</p> -->
      <!-- <p>Hi {{checkProperty(getUserData, 'name')}}, we help you to seamlessly manage your public access files and I-9s here.</p> -->
      <p v-if="[48, 50].indexOf(getUserRoleId) > -1">Welcome, <strong>{{checkProperty(getUserData, 'firstName')}}</strong>! This dashboard shows the status of all <strong>{{checkProperty(getUserData, 'companyName')}}</strong> cases.</p>
      <p v-if="[12].indexOf(getUserRoleId) > -1">Welcome, <strong>{{checkProperty(getUserData, 'firstName')}}</strong>! This dashboard shows the status of your assigned cases.</p>

    </div>
    <div class="d-flex gap-3" v-if="((checkPetInvitePermisions || [48,50].indexOf(getUserRoleId)>-1) && (pafPackage || multiplePackage)) ||
      ([49,12,51].indexOf(getUserRoleId) <= -1 && ( i9Package || multiplePackage ))">
      <button v-if="(checkPetInvitePermisions || [48,50].indexOf(getUserRoleId)>-1) && (pafPackage || multiplePackage)" 
      color="primary" type="border" class="btn light_blue_btn" 
      @click="openPopup('PAF')">+ New PAF<span>
      </span></button>
      <button v-if="[49,12,51].indexOf(getUserRoleId) <= -1 && ( i9Package || multiplePackage )" color="primary" type="border" class="btn light_blue_btn mr-2" @click="openPopup('I9')">+ Request I-9<span>
      </span></button>
    </div>
    </div>
    <!-- <div class="db_sec marb30">
      <div class="db_cnt" v-if="pafPackage || multiplePackage">
          <div class="db_block">
            <div class="block_head">
              <h2>Public Access File</h2>
              <a @click="openPaf()">+ NEW PAF</a>
            </div>
            <div class="block_cnt">
              <ul>
                <template v-for="(pItem, inde) in pafData">
                  <li @click="redirectToListPage(pItem, 'paf')">
                    <a class="card_cnt" :class="{'navigate_paf': pItem['name'] != 'Awaiting Employee Acknowledgment of LCA Receipt'}">
                      <span>{{pItem['count']}}</span>
                      <label>{{pItem['name']}}</label>
                    </a>
                  </li>
                </template>
                
                <li>
                  <div class="card_cnt">
                    <span>32</span>
                    <label>Awaiting Beneficiary Confirmation</label>
                  </div>
                </li>
                <li>
                  <div class="card_cnt">
                    <span>11</span>
                    <label>Awaiting Petitioner Signature</label>
                  </div>
                </li>
                <li>
                  <div class="card_cnt">
                    <span>61</span>
                    <label>Completed</label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
      </div>
      <div class="db_cnt" v-if="i9Package || multiplePackage">
        <div class="db_block db_i9_block">
          <div class="block_head">
            <h2>Form I-9</h2>
            <a @click="openi9()">+ NEW I-9</a>
          </div>
          <div class="block_cnt">
            <ul>
              <template v-for="(pItem, inde) in i9Data"> 
                  <li @click="redirectToListPage(pItem, 'i9')">
                    <a class="i9_card">
                      <span>{{pItem['count']}}</span>
                      <label>{{pItem['name']}}</label>
                    </a>
                  </li>
                </template>
              <li>
                <a class="i9_card">
                  <span>54</span>
                  <label>Pending with Employee</label>
                </a>
              </li>
              <li>
                <div class="i9_card">
                  <span>32</span>
                  <label>Verifier Selection</label>
                </div>
              </li>
              <li>
                <div class="i9_card">
                  <span>11</span>
                  <label>Verification Process</label>
                </div>
              </li>
              <li>
                <div class="i9_card">
                  <span>61</span>
                  <label>Confirm Documents</label>
                </div>
              </li>
              <li>
                <div class="i9_card">
                  <span>14</span>
                  <label>Employer Confirmation</label>
                </div>
              </li>
              <li>
                <div class="i9_card">
                  <span>21</span>
                  <label>E-Verify</label>
                </div>
              </li>
            </ul>
          </div>
        </div>
    </div>
    </div>  -->
    <div class="db_sec marb30 flex-wrap">
      <div class="db_cnt marb30">
          <div class="db_block db_i9_block">
            <div class="block_head">
              <h2>Action Required</h2>
            </div>
            <div class="block_content">
              <vs-tabs>
                <vs-tab label="Form I-9">
                  <div class="con-tab-ejemplo">
                    <div class="block_cnt" v-if="multiplePackage || i9Package">
                      <ul>
                        <template v-for="(pItem, inde) in i9Data" v-if="checkProperty(pItem, 'widget') && checkProperty(pItem, 'widget') === 1">
                          <li @click="redirectToListPage(pItem, 'i9')">
                            <a class="i9_card" >
                              <span>{{pItem['count']}}</span>
                              <label>{{pItem['name']}}</label>
                            </a>
                          </li>
                        </template>
                      </ul>
                    </div>
                    <div v-else>
                      <span>This feature requires an active I-9 subscription. Please upgrade your plan to access the I-9 Dashboard.</span>
                    </div>
                  </div>
                </vs-tab>
                <vs-tab label="PAF">
                  <div class="con-tab-ejemplo" v-if="multiplePackage || pafPackage">
                    <div class="block_cnt">
                      <ul>
                        <template v-for="(pItem, inde) in pafData" v-if="checkProperty(pItem, 'widget') && checkProperty(pItem, 'widget') === 1">
                          <li @click="redirectToListPage(pItem, 'paf')">
                            <a class="i9_card" >
                              <span>{{pItem['count']}}</span>
                              <label>{{pItem['name']}}</label>
                            </a>
                          </li>
                        </template>
                      </ul>
                    </div>
                  </div>
                  <div v-else>
                    <span>This feature requires an active PAF subscription. Please upgrade your plan to access the PAF Dashboard.</span>
                  </div>
                </vs-tab>
              </vs-tabs>
            </div>
          </div>
      </div>
      <div class="db_cnt marb30">
        <div class="db_block db_i9_block">
          <div class="block_head">
            <h2>Waiting on others</h2>
          </div>
          <div class="block_content">
          <vs-tabs>
              <vs-tab label="Form I-9">
                <div class="con-tab-ejemplo" v-if="multiplePackage || i9Package">
                  <div class="block_cnt">
                    <ul>
                      <template v-for="(pItem, inde) in i9Data" v-if="checkProperty(pItem, 'widget') && checkProperty(pItem, 'widget') === 2"> 
                        <li @click="redirectToListPage(pItem, 'i9')">
                          <a class="i9_card">
                            <span>{{pItem['count']}}</span>
                            <label>{{pItem['name']}}</label>
                          </a>
                        </li>
                      </template>
                    </ul>
                  </div>
                </div>
                <div v-else>
                  <span>This feature requires an active I-9 subscription. Please upgrade your plan to access the I-9 Dashboard.</span>
                </div>
              </vs-tab>
              <vs-tab label="PAF">
                <div class="con-tab-ejemplo" v-if="multiplePackage || pafPackage">
                  <div class="block_cnt">
                    <ul>
                      <template v-for="(pItem, inde) in pafData" v-if="checkProperty(pItem, 'widget') && checkProperty(pItem, 'widget') === 2"> 
                        <li @click="redirectToListPage(pItem, 'paf')">
                          <a class="i9_card">
                            <span>{{pItem['count']}}</span>
                            <label>{{pItem['name']}}</label>
                          </a>
                        </li>
                      </template>
                    </ul>
                  </div>
                </div>
                <div v-else>
                  <span>This feature requires an active PAF subscription. Please upgrade your plan to access the PAF Dashboard.</span>
                </div>
              </vs-tab>
            </vs-tabs>
          </div>
        </div>
      </div>
      <div class="db_cnt marb30">
        <div class="db_block db_i9_block">
          <div class="block_head">
            <h2>Follow-ups due</h2>
          </div>
          <div class="block_content">
            <vs-tabs>
              <vs-tab label="Form I-9">
                <div class="con-tab-ejemplo" v-if="multiplePackage || i9Package">
                  <div class="block_cnt">
                    <ul>
                      <template v-for="(pItem, inde) in i9Data" v-if="checkProperty(pItem, 'widget') === 3"> 
                        <li @click="redirectToListPage(pItem, 'i9')">
                          <a class="i9_card">
                            <span>{{pItem['count']}}</span>
                            <label>{{pItem['name']}}</label>
                          </a>
                        </li>
                      </template>
                    </ul>
                  </div>
                </div>
                <div v-else>
                  <span>This feature requires an active I-9 subscription. Please upgrade your plan to access the I-9 Dashboard.</span>
                </div>
              </vs-tab>
              <vs-tab label="PAF">
                <div class="con-tab-ejemplo" v-if="multiplePackage || pafPackage">
                  <div class="block_cnt">
                    <ul>
                      <template v-for="(pItem, inde) in pafData" v-if="checkProperty(pItem, 'widget') === 3"> 
                        <li @click="redirectToListPage(pItem, 'paf')">
                          <a class="i9_card">
                            <span>{{pItem['count']}}</span>
                            <label>{{pItem['name']}}</label>
                          </a>
                        </li>
                      </template>
                    </ul>
                  </div>
                </div>
                <div v-else>
                  <span>This feature requires an active PAF subscription. Please upgrade your plan to access the PAF Dashboard.</span>
                </div>
              </vs-tab>
            </vs-tabs>
          </div>
        </div>
      </div>
      <div class="db_cnt marb30">
          <div class="db_block db_i9_block">
            <div class="block_head">
              <h2>Completed</h2>
            </div>
            <div class="block_content">
            <vs-tabs>
                <vs-tab label="Form I-9">
                  <div class="con-tab-ejemplo" v-if="multiplePackage || i9Package">
                    <div class="block_cnt">
                      <ul>
                        <template v-for="(pItem, inde) in i9Data" v-if="checkProperty(pItem, 'widget') === 4"> 
                          <li @click="redirectToListPage(pItem, 'i9')">
                            <a class="i9_card">
                              <span>{{pItem['count']}}</span>
                              <label>{{pItem['name']}}</label>
                            </a>
                          </li>
                        </template>
                      </ul>
                    </div>
                  </div>
                  <div v-else>
                    <span>This feature requires an active I-9 subscription. Please upgrade your plan to access the I-9 Dashboard.</span>
                  </div>
                </vs-tab>
                <vs-tab label="PAF">
                  <div class="con-tab-ejemplo" v-if="multiplePackage || pafPackage">
                    <div class="block_cnt">
                      <ul>
                        <template v-for="(pItem, inde) in pafData" v-if="checkProperty(pItem, 'widget') === 4"> 
                          <li @click="redirectToListPage(pItem, 'paf')">
                            <a class="i9_card">
                              <span>{{pItem['count']}}</span>
                              <label>{{pItem['name']}}</label>
                            </a>
                          </li>
                        </template>
                      </ul>
                    </div>
                  </div>
                  <div v-else>
                    <span>This feature requires an active PAF subscription. Please upgrade your plan to access the PAF Dashboard.</span>
                  </div>
                </vs-tab>
              </vs-tabs>
              </div>
          </div>
      </div>
    </div> 
    

    <template v-if="false">
      <UpdateI9></UpdateI9>
      <AssignVerifier></AssignVerifier>
    </template>
    

  </div>
</template>
<script> 
  import AssignVerifier from "@/views/i-9Module/assignVerifier.vue";
  import UpdateI9 from "@/views/i-9Module/updateI9.vue";

  export default {
    data() {
      return {
        pafPackage:null,
        i9Package:null,
        multiplePackage:null,
        existingPlanDetails:null,
        pafData:[],
        i9Data:[],
        "paf": [
          {
            count:75,
            "statusIds": [
              1
            ],
            "name": "initiated"
          },
          {
            count:55,
            "statusIds": [
              2
            ],
            "name": "Awaiting Petitioner Confirmation"
          },
          {
            count:5,
            "statusIds": [
              3
            ],
            "name": "Awaiting Beneficiary Confirmation"
          },
          {
            count:7,
            "statusIds": [
              4
            ],
            "name": "Completed"
          }
        ],
        i9CaseStatus: []
      };
    },
    components: { 
      AssignVerifier,
      UpdateI9
    },
    methods:{
      openPopup(type) {
        if (type == 'PAF') {
          this.$router.push({ name: 'PAF Requests', params: { openCreatePopup: true } });
        }else if(type == 'I9') {
          this.$router.push({ name: 'Form I-9', params: { openCreatePopup: true } });
        } 
      },
      getPlanDetails(){
      try {
        let response = JSON.parse(localStorage.getItem('selectedPlans'))//localStorage.getItem('selectedPlans')//
        // console.log(response, 'response=response')
        if(response){
          this.existingPlanDetails = response;
          if(this.existingPlanDetails && this.checkProperty(this.existingPlanDetails, 'length')>0){
            this.pafPackage = _.find(this.existingPlanDetails,(item)=>{
            if(((item['planDetails']&& item['planDetails']['name'] && item['planDetails']['name']== 'PAF25') || (item['packageType']&& item['packageType']=='PAF'))){ 
              return item
            }
          })
          this.i9Package = _.find(this.existingPlanDetails,(item)=>{
            if(((item['planDetails']&& item['planDetails']['name'] && item['planDetails']['name']== 'I925') || (item['packageType']&& item['packageType']=='I9'))){
              return item
            }
          })
          this.multiplePackage = _.find(this.existingPlanDetails,(item)=>{
            if(((item['planDetails']&& item['planDetails']['name'] && item['planDetails']['name']== 'I925PAF25') || (item['packageType']&& item['packageType']=='PAFI9'))){
              return item
            }
          })

      }
        }
      } catch (error) {
        console.error( error);
      }
    },
      openPaf(){
        this.$router.push({ name: 'PAF Requests', params: {openCreatePopup: true}}).catch(err => { })
      },
      openi9(){
        this.$router.push({ name: 'Form I-9', params: {openCreatePopup: true}}).catch(err => { })
      },
      getStats(){
        let payLoad={};
        let path = '/dashboard/get-dashboard-stats';
        this.$store.dispatch('commonAction', {data:payLoad, path:path}).then((res)=>{
          if(res){
            if(res['i9'] && res['i9']['length']>0){
              this.i9Data = res['i9'];
              // let i9Counts = {};
              // _.forEach(res['i9'], eachStat => {
              //   i9Counts = Object.assign(i9Counts, {
              //     [`${eachStat.name}`]: eachStat['count']
              //   })
              // })

              // _.forEach(this.i9CaseStatus, (status) => {
              //   if (this.checkProperty(i9Counts, `${status.name}`)) {
              //     status["count"] = i9Counts[status.name]
              //   } else {
              //     status["count"] = 0;
              //   }
              // })
              // this.i9Data = this.i9CaseStatus;
            }
            if(res['paf'] && res['paf']['length']>0){
              // this.pafData = res['paf'];
              this.getAwaitingSignCount(res['paf']);
              this.getEmployeeNotAssignedStats(res['paf']);
            }
            else{
              this.getAwaitingSignCount([]);
              this.getEmployeeNotAssignedStats([]);
            }
          }
        }).catch((err)=>{
             this.getAwaitingSignCount([]);
             this.getEmployeeNotAssignedStats([]);
        })
      },
      getAwaitingSignCount(pafStat=[]){
        let payLoad={ };
        let path = '/dashboard/ack-stats';
        this.$store.dispatch('commonAction', {data:payLoad, path:path}).then((res)=>{
          if(res && this.checkProperty(res, 'length') > 0){
            pafStat.push(res[0])
            this.pafData = pafStat;
          }
        }).catch((err)=>{
          this.pafData = pafStat;
        })
      },
      getEmployeeNotAssignedStats(pafStat=[]){
        let payLoad={ };
        let path = '/dashboard/emp-not-assgn-stats';
        this.$store.dispatch('commonAction', {data:payLoad, path:path}).then((res)=>{
          if(res && this.checkProperty(res, 'length') > 0){
            pafStat.push(res[0])
            this.pafData = pafStat;
          }
        }).catch((err)=>{
          this.pafData = pafStat;
        })
      },
      getI9StatsMasterData() {
        this.i9CaseStatus = []
        let payLoad = {
          category: "i9_form_status",
        };
        this.$store.dispatch('commonAction', { data: payLoad, path: '/masterdata/list' }).then((res) => {
          this.i9CaseStatus = res.list;
          _.forEach(this.i9CaseStatus, eachStatus => eachStatus["count"] = 0);
          this.i9Data = this.i9CaseStatus
        }).catch((err) => {
          this.i9CaseStatus = []
        })
      }
    },
    mounted(){
      // this.getI9StatsMasterData()
      this.getStats();
      this.getPlanDetails();
    }
    
  };
</script>
